// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","layout":false,"id":"1"},"2":{"path":"/products","layout":false,"id":"2"},"3":{"path":"/contact","layout":false,"id":"3"},"4":{"path":"/companyProfile","layout":false,"id":"4"},"5":{"path":"/factory","layout":false,"id":"5"},"6":{"path":"/news","layout":false,"id":"6"},"7":{"path":"/industry-news","layout":false,"id":"7"},"8":{"path":"/faq","layout":false,"id":"8"},"9":{"path":"/technology","layout":false,"id":"9"},"10":{"path":"*","layout":false,"id":"10"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__Welcome" */'@/pages/Welcome.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__ProductCenter" */'@/pages/ProductCenter.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__ContactUs" */'@/pages/ContactUs.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__CompanyProfile" */'@/pages/CompanyProfile.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__factory" */'@/pages/factory.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__CompanyNews" */'@/pages/CompanyNews.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__IndustryNews" */'@/pages/IndustryNews.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__Faq" */'@/pages/Faq.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__TechnologyCenter" */'@/pages/TechnologyCenter.tsx')),
'10': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'D:/wwwroot/web/dev-nbthc.com/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
